import cn from 'classnames';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartEmpty = () => {
  const { miniCartData } = useCartContext();
  const featuredItems = new Map(Object.entries(miniCartData.featured));

  return (
    <div class="text-center">
      <h2 class="type-heading-5">{miniCartData.settings.emptyCartMessage}</h2>

      {featuredItems && featuredItems.length > 0 !== null ? (
        <div class="mt-4 flex flex-col gap-y-6">
          {[...featuredItems.keys()].map(key => {
            const item = featuredItems.get(key);
            return (
              <div
                key={key}
                class={cn(
                  'relative flex h-60 flex-col items-start justify-between rounded-lg py-8 pl-6',
                  item.background,
                )}
              >
                <a href={item.url} class="absolute inset-0 h-full w-full"></a>
                <img
                  src={item.image}
                  class="absolute right-0 top-0 h-full w-32 rounded-l-full object-cover"
                />
                <h3 class="type-heading-3 flex w-32 text-left">{item.title}</h3>
                <span class="type-small self-start underline">{item.cta}</span>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default CartEmpty;
